var render = function render(){var _vm=this,_c=_vm._self._c;return _c('person-data-detail',{attrs:{"person-url":_vm.$route.params.personUrl,"data-id":_vm.$route.params.dataId},on:{"data-id-changed":_vm.dataIdChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }